import { FC } from 'react'

import { Link, useNavigate } from '@tanstack/react-router'

import { Button, Typography } from '@forto-dev/phoenix-ui-core/common'
import { Brand, Header as HeaderComponent } from '@forto-dev/phoenix-ui-core/ship'

import { useAuth } from '@/features/auth'
import { SearchlightSearch } from '@/features/searchlight/components/searchlightSearch'
import { useLocalisation } from '@/utils/localisation'

import { Cockpit } from './cockpit'

type HeaderProps = {
  hideBookShipmentButton?: boolean
}
export const Header: FC<HeaderProps> = ({ hideBookShipmentButton = false }) => {
  const { customer, isCustomerActive } = useAuth()
  const { translate } = useLocalisation()
  const navigate = useNavigate()

  const handleBookShipment = () => {
    navigate({ to: '/bookings/create' })
  }

  return (
    <HeaderComponent
      logo={
        <Link to="/">
          <Brand suffix={<Typography variant="h4">{customer?.name}</Typography>} />
        </Link>
      }
      search={<SearchlightSearch />}
      actions={
        !hideBookShipmentButton && isCustomerActive ? (
          <Button onClick={handleBookShipment} variant="primary">
            {translate('actions.book')}
          </Button>
        ) : null
      }
      cockpit={<Cockpit />}
    />
  )
}
